module.exports = __webpack_public_path__ + "img/visa.d100e9f8.svg";